import { render, staticRenderFns } from "./dictInspection-item.vue?vue&type=template&id=3a6f0eba&scoped=true"
import script from "./dictInspection-item.vue?vue&type=script&lang=js"
export * from "./dictInspection-item.vue?vue&type=script&lang=js"
import style0 from "./dictInspection-item.vue?vue&type=style&index=0&id=3a6f0eba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6f0eba",
  null
  
)

export default component.exports